import { Component } from '@angular/core';
import { ShimmerLoadingComponent } from '../shimmer-loading/shimmer-loading.component';
import { ConfigService } from '../core';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { WhiteLabelNames } from '../../enums/white-label.enum';
import { combineLatest } from 'rxjs';

@Component({
    selector: "app-shimmer-loading-patientweb",
    imports: [ShimmerLoadingComponent, CommonModule],
    templateUrl: "./shimmer-loading-patientweb.component.html",
    styleUrl: "./shimmer-loading-patientweb.component.scss"
})
export class ShimmerLoadingPatientwebComponent {
	isUkDfp$ = this.config.config$.pipe(
		map((config) => config.WhiteLabelName === WhiteLabelNames.UK_DFP)
	);
	isGlobal$ = this.config.config$.pipe(
		map((config) => config.WhiteLabelName === WhiteLabelNames.GLOBAL)
	);

	logo$ = combineLatest([this.isUkDfp$, this.isGlobal$]).pipe(
    map(([isUkDfp, isGlobal]) => {
      if (isGlobal) {
        return '/assets/img/global-synlab-logo.png';
      } else if (isUkDfp) {
        return '/assets/img/ukdfplogo.png';
      } else {
        return '/assets/img/synlab-logo.svg';
      }
    })
	);

	constructor(private config: ConfigService) {}
}
